/**
* Phone CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Phone CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'phone-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.splide-marquee-rtl' ).length ) {
        $( '.splide-marquee-rtl' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            autoWidth: true,
            gap: '32px',
            pauseOnHover: false,
            pauseOnFocus: false,
            pagination: false,
            autoScroll: {
              speed: 0.3,
            },
            arrows: false,
          } ).mount( {AutoScroll} );
        } );
      }

      if ( $( '.splide-marquee-ltr' ).length ) {
        $( '.splide-marquee-ltr' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            autoWidth: true,
            gap: '32px',
            pauseOnHover: false,
            pauseOnFocus: false,
            pagination: false,
            autoScroll: {
              speed: -0.25,
            },
            arrows: false,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'phone-cta', COMPONENT );
} )( app );
